import { Injectable, Injector } from '@angular/core';
// @dynamic

@Injectable({
  providedIn: 'root'
})

export class CoreDependencyInjectorService {
  private static injector: Injector;

  /**
   * set injector
   * @param injector - instance
   */
  static setInjector(injector: Injector) {
    CoreDependencyInjectorService.injector = injector;
  }

  /**
   * Get injector
   */
  static getInjector(): Injector {
    return CoreDependencyInjectorService.injector;
  }
}
